import { render, staticRenderFns } from "./CreativeMemory.vue?vue&type=template&id=7c84a116&scoped=true&"
import script from "./CreativeMemory.vue?vue&type=script&lang=js&"
export * from "./CreativeMemory.vue?vue&type=script&lang=js&"
import style0 from "./CreativeMemory.vue?vue&type=style&index=0&id=7c84a116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84a116",
  null
  
)

/* custom blocks */
import block0 from "./CreativeMemory.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports